import * as angular from 'angular';

const module = angular.module('messages-page-components', []);

export { module };
